import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import pretty from '@st-operations/uikit/lib/pretty'

import './styles.scss'

const TabView = ({ options, onSelect, active }) => {
  return (
    <div className="tab-view">
      <For each="option" of={options}>
        <button
          key={option}
          className={classNames('tab-view__button', {
            'tab-view__button--active': active === option,
          })}
          onClick={() => onSelect(option)}
        >
          {pretty(option)}
        </button>
      </For>
    </div>
  )
}

TabView.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  active: PropTypes.string.isRequired,
}

export default TabView
